import React, { Component } from 'react';
import Navbar from '../HeaderComponents/Navbar';
import Home from './Home';
import DashBoard from './../DashBoard';
import MenuBar from './../HeaderComponents/MenuBar';
import withAuth from './../../auth_components/js/withAuth';

class Tender extends Component {
  render() {
    return (
      <div>
        <DashBoard history={this.props.history} user={this.props.user} />
        <MenuBar />
        <Home />
      </div>
    )
  }
}
export default withAuth(Tender);


// WEBPACK FOOTER //
// ./src/HomeComponents/Tender/Tender.js